import { useCallback, useMemo } from 'react';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';
import { AppPage } from 'common/models/page-config.models';

interface UserPermissions {
  hasPermission: (page: string | string[]) => boolean;
}

export function useProjectPermissions(): UserPermissions {
  const { activeProject } = useModuleProjectContext();
  const projectPages: AppPage[] = useMemo(() => activeProject?.pages ?? [], [activeProject]);

  const hasPermission = useCallback(
    (page: string | string[]) => {
      const pages = Array.isArray(page) ? page : [page];

      return pages.every((pageItem) =>
        projectPages.some((projectPage) => projectPage.Route === pageItem)
      );
    },
    [projectPages]
  );

  return { hasPermission };
}
